// Upali ga sa ?debug=1 u URL-u ili localStorage.debugPricing = "1"
export const DBG_ON =
  new URLSearchParams(window.location.search).has("debug") ||
  localStorage.getItem("debugPricing") === "1";

export function dbg(...args) {
  if (DBG_ON) console.log("%c[PRICING]", "color:#4b8; font-weight:700", ...args);
}

export function table(label, rows) {
  if (DBG_ON && Array.isArray(rows)) {
    console.log("%c" + label, "color:#888");
    console.table(rows);
  }
}
